import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { GENERATION_MODES } from "../../pricing-configurator.const";
import { GenerationModeEnum } from "../../pricing-configurator.types";

type PricingGenerationModeProps = {
  generationMode: GenerationModeEnum;
  onGenerationModeChange: (mode: GenerationModeEnum) => void;
  timeStep: number;
  onTimeStepChange: (step: number) => void;
  priceStep: number;
  onPriceStepChange: (step: number) => void;
};

export const PricingGenerationMode = ({
  generationMode,
  onGenerationModeChange,
  timeStep,
  onTimeStepChange,
  priceStep,
  onPriceStepChange,
}: PricingGenerationModeProps) => {
  return (
    <div className="space-y-2">
      {GENERATION_MODES.map((mode) => {
        const isSelected = generationMode === mode.value;
        const showTimeInput = isSelected && mode.value === GenerationModeEnum.TIME_STEP;
        const showPriceInput = isSelected && mode.value === GenerationModeEnum.PRICE_STEP;

        return (
          <div
            key={mode.value}
            className={cn(
              "rounded-md border transition-all duration-200",
              isSelected ? "border-primary bg-primary/5" : "border-border hover:bg-muted/50",
            )}
          >
            <label className="flex cursor-pointer items-start gap-3 p-3">
              <input
                type="radio"
                value={mode.value}
                checked={isSelected}
                onChange={(e) => onGenerationModeChange(e.target.value as GenerationModeEnum)}
                className="mt-0.5 accent-primary"
              />
              <div className="flex-1">
                <div className="text-sm font-medium">{mode.title}</div>
                <div className="text-xs text-muted-foreground">{mode.description}</div>
              </div>
            </label>

            {showTimeInput && (
              <div className="px-3 pb-3 pt-1 animate-in fade-in slide-in-from-top-2 duration-200">
                <div className="flex items-center gap-2 rounded-md bg-muted/50 p-2">
                  <span className="text-sm text-muted-foreground">Toutes les</span>
                  <Input
                    type="number"
                    value={timeStep}
                    onChange={(e) => onTimeStepChange(parseInt(e.target.value) || 1)}
                    className="h-8 w-20"
                  />
                  <span className="text-sm text-muted-foreground">minutes</span>
                </div>
              </div>
            )}

            {showPriceInput && (
              <div className="px-3 pb-3 pt-1 animate-in fade-in slide-in-from-top-2 duration-200">
                <div className="flex items-center gap-2 rounded-md bg-muted/50 p-2">
                  <span className="text-sm text-muted-foreground">Tous les</span>
                  <Input
                    type="number"
                    value={priceStep}
                    onChange={(e) => onPriceStepChange(parseFloat(e.target.value) || 0.1)}
                    className="h-8 w-20"
                  />
                  <span className="text-sm text-muted-foreground">€</span>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
